import { InspectorAdvancedControls } from "@wordpress/block-editor";
import { BlockEditProps } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
import React from "react";
import { DEVICES, HTML_MARKUP } from "../../constants";
import { Dimensions, Input, Select, Slider } from "../../controls";
import Panel from "./Panel";

type ResponsiveValue = {
	[key in keyof typeof DEVICES]?: {
		top?: number;
		right?: number;
		bottom?: number;
		left?: number;
		unit?: string;
	};
};

type Props = {
	blockMargin?: ResponsiveValue | undefined;
	blockPadding?: ResponsiveValue;
	blockZIndex?: number;
	cssID?: string;
	blockHTML?: string;
	setAttributes: BlockEditProps<any>["setAttributes"];
	className?: string;
};

const AdvancedControls: React.FC<Props> = (props) => {
	const {
		blockMargin,
		blockPadding,
		blockZIndex,
		cssID,
		setAttributes,
		blockHTML,
		className,
	} = props;
	return (
		<React.Fragment>
			<Panel title={__("Spacing", "magazine-blocks")} initialOpen={true}>
				<Dimensions
					value={blockMargin as any}
					responsive
					label={__("Block Margin", "magazine-blocks")}
					defaultUnit="px"
					units={["px", "rem", "em", "%"]}
					onChange={(val) => setAttributes({ blockMargin: val })}
					type="margin"
					resetAttributeKey="blockMargin"
				/>
				<Dimensions
					value={blockPadding as any}
					responsive
					label={__("Block Padding", "magazine-blocks")}
					defaultUnit="px"
					units={["px", "rem", "em", "%"]}
					onChange={(val) => setAttributes({ blockPadding: val })}
					resetAttributeKey="blockPadding"
				/>
			</Panel>
			<Panel title={__("Z-index", "magazine-blocks")}>
				<Slider
					label={__("Z-Index", "magazine-blocks")}
					value={blockZIndex as any}
					min={0}
					max={10000}
					step={1}
					onChange={(val) => setAttributes({ blockZIndex: val })}
					resetAttributeKey="blockZIndex"
				/>
			</Panel>
			<InspectorAdvancedControls>
				<Input
					onChange={(val) => setAttributes({ cssID: val })}
					label={__("CSS ID", "magazine-blocks")}
					value={cssID ?? ""}
					style={{ marginBottom: "16px" }}
				/>
				<Input
					value={className}
					label={__("Additional CSS Class(Es)", "magazine-blocks")}
					onChange={(val) => setAttributes({ className: val })}
					style={{ marginBottom: "16px" }}
				/>
				<Select
					label={__("Block HTML", "magazine-blocks")}
					value={blockHTML}
					onChange={(val) => setAttributes({ blockHTML: val })}
					options={HTML_MARKUP}
				/>
			</InspectorAdvancedControls>
		</React.Fragment>
	);
};

export default AdvancedControls;
